import { Mail } from "lucide-react";
import { Link, useSearchParams } from "react-router";

import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

export function VerifyEmailPage() {
  const [searchParams] = useSearchParams();
  const email = searchParams.get("email");

  return (
    <div className="bg-background flex min-h-screen items-center justify-center px-4">
      <Card className="w-full max-w-md">
        <CardHeader className="text-center">
          <div className="bg-accent/10 mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-full">
            <Mail className="text-accent h-8 w-8" />
          </div>
          <p className="text-primary text-xs font-semibold tracking-[0.22em] uppercase">
            Johnson &amp; Johnson Vision
          </p>
          <CardTitle className="font-heading text-foreground text-2xl font-semibold tracking-tight">
            Check your email
          </CardTitle>
        </CardHeader>
        <CardContent className="text-center">
          <p className="text-muted mb-6">
            We&apos;ve sent a verification link to{" "}
            {email ? (
              <span className="text-foreground font-medium">{email}</span>
            ) : (
              "your email address"
            )}
            . Please confirm your address before accessing the UKDC decision workspace.
          </p>
          <p className="text-muted mb-6 text-sm">
            Didn&apos;t receive the email? Check your spam folder or submit your request again.
          </p>
          <Button asChild variant="outline" className="w-full">
            <Link to="/login">Back to sign in</Link>
          </Button>
        </CardContent>
      </Card>
    </div>
  );
}
